import { gql } from "apollo-boost";

export const QUERY_RANDOM_WOW = gql`
query WowRandom {
  wowByRandom {
      title
      slug
  }
}
`;